/**
 * Labstep
 *
 * @module core/Form/ReactForm/Checkbox
 * @desc Wrapper around semantic-ui-react Checkbox
 */

import { Checkbox as CoreCheckbox } from 'labstep-web/core/Checkbox';
import type React from 'react';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import type { ICheckboxProps } from './types';

export const Checkbox: React.FC<ICheckboxProps> = ({
  elementProps,
  control,
  name,
  autoFocus,
  onKeyPress,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field }): React.ReactElement => {
      const { onChange } = field;
      const { value } = field;
      useEffect(() => {
        if (elementProps?.defaultValue) {
          field.onChange(elementProps.defaultValue);
        }
      }, []);

      // Remove 'value' from field before spreading to CoreCheckbox
      const { value: _omitValue, ...fieldWithoutValue } = field;
      return (
        <CoreCheckbox
          {...fieldWithoutValue}
          checked={!!value}
          {...elementProps}
          {...rest}
          onChange={(e, data): void => {
            onChange(data.checked as any);
          }}
        />
      );
    }}
  />
);
